import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedUserRoute = ({ children }) => {
  const userToken = localStorage.getItem("userToken"); 

  return userToken ? children : <Navigate to="/user-login" />;
};

export default ProtectedUserRoute;
